import { useDispatch } from '../Store/storeProvider';
import setupCookies from '../Helpers/setupCookies';
import Metering from '../Handlers/Metering';
import ComboType from '../Handlers/ComboType';
import { readCookie } from '../Helpers/Cookies';
import {
    setSuscriptorType,
    setRegistrado,
    save,
    setUserId,
    createCustomDimension,
} from '../Helpers/CustomDimension';
import UCL from '../Helpers/UserClientLibs';
const useCookiesHandler = () => {
    const dispatch = useDispatch();

    const handler = async (callback, onIdentityPrepared) => {
        try {
            const userTokenData = await UCL.GetUserInfo();

            setupCookies(userTokenData);

            await Metering.obtenerCookieSuscriptor();
            await ComboType.obtenerCookieComboType();

            let combotype = readCookie('gaComboType');
            if (combotype) {
                setSuscriptorType(combotype);
            } else {
                setSuscriptorType('N/A');
            }

            //CustomDimension
            setUserId(userTokenData.ln_user_id);
            setRegistrado('yes');
            save();
            createCustomDimension();

            if (onIdentityPrepared) {
                try {
                    await onIdentityPrepared(userTokenData);
                } catch {
                    console.warn('No se pudo completar el tracking de identidad.');
                }
            }

            window.location = callback;
        } catch (error) {
            console.error(error, ' error handleMeService');
            dispatch({
                type: 'ERROR PAGE COMPONENT',
                value: 'error generico',
            });
            throw error;
        }
    };

    return [handler];
};

export default useCookiesHandler;
